module.exports = __webpack_public_path__ + "assets/img/7b01-jo.svg";